import Heading from './heading';
import SubHeading from './sub-heading';
import Body from './body';
import Label from './label';
import Tag from './tag';

export { Heading, SubHeading, Body, Label, Tag };
